import styles from './CookieBanner.scss';

import cx from 'classnames';
import { Entry } from 'contentful';
import * as React from 'react';

import { WithTranslation, withTranslation } from 'react-i18next';
import { BannerAssembly, ContentType } from 'src/api/contentful/contentTypes.cloverdotcom';
import { ContentfulEntry, ContentfulEntryRenderProps } from 'src/components/EntryLoader/ContentfulEntry';
import { eraseCookie, readCookie, setCookie } from 'src/utils/Cookies';
import { BannerModule } from '../BannerModule/BannerModule';

export const COOKIE_BANNER_COOKIE_NAME = 'cookieConsentSeen';

export interface ICookieBannerProps extends WithTranslation, React.AllHTMLAttributes<HTMLElement> {
  entry?: Entry<BannerAssembly>;
}

export interface ICookieBannerState {
  hasAcknowledgedPrivacyPolicy: boolean;
}

const CookieBanner = (props: ICookieBannerProps, context?: any) => {
  const [hasAcknowledgedPrivacyPolicy, setAcknowledgedPrivacyPolicy] = React.useState(!!readCookie(COOKIE_BANNER_COOKIE_NAME));
  const { entry, className, t, i18n, tReady, ...rest } = props;

  if (!entry || i18n.language === 'en-US') return null;

  const applyHasAcknowledgedPrivacyPolicy = (value: boolean) => {
    if (value) {
      // Enables cookie to be read by `*.clover` subdomains
      // Will fail locally; domain specified differs from localhost
      setCookie(COOKIE_BANNER_COOKIE_NAME, new Date().toISOString(), undefined, true);
    } else {
      eraseCookie(COOKIE_BANNER_COOKIE_NAME, true);
    }
    setAcknowledgedPrivacyPolicy(value);
  };

  const onClick: React.MouseEventHandler<HTMLButtonElement> = e => {
    e.preventDefault();
    applyHasAcknowledgedPrivacyPolicy(true);
  };

  if (hasAcknowledgedPrivacyPolicy) { return null; }

  return (
    <BannerModule
      notCentered
      tagName="header"
      className={cx(styles.cookieBannerWrapper, className)}
      entry={entry}
      button={(
        <button className={styles.button} onClick={onClick}>
          {t('ok')}
        </button>
      )}
      {...rest}
    />
  );
};

const Translated = withTranslation()(CookieBanner);
type Translated = typeof Translated;

const DotcomCookieBanner: React.FC<React.AllHTMLAttributes<HTMLElement>> = props => (
  <ContentfulEntry entryId="1qIOIz9GQ4qkqqKqIiASkw" contentType={ContentType.BANNER_ASSEMBLY}>
    {({ isLoading, hasError, notFound, entry }: ContentfulEntryRenderProps<BannerAssembly>) => {
      if (isLoading || hasError || notFound || !entry) return null;

      return <Translated {...props} entry={entry} />;
    }}
  </ContentfulEntry>
);

export {
  DotcomCookieBanner as CookieBanner,
  CookieBanner as _InternalCookieBanner,
  Translated as InternalCookieBanner,
};
